var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1304.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Audio",
    transform: "translate(824.000000, 1304.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0129439,0 C29.7399788,4.284 32,9.876 32,16 C32,22.124 29.7399788,27.716 26.0129439,32 L26.0129439,32 L23.5869211,30.102 C26.9129523,26.336 28.9509714,21.407 28.9509714,16 C28.9509714,10.593 26.9129523,5.664 23.5869211,1.898 L23.5869211,1.898 Z M21.1896987,3.7744 C24.108726,7.0164 25.9007428,11.2944 25.9007428,16.0004 C25.9007428,20.7064 24.108726,24.9834 21.1896987,28.2254 L21.1896987,28.2254 L18.7786761,26.3384 C21.2966997,23.6174 22.8507142,19.9914 22.8507142,16.0004 C22.8507142,12.0084 21.2966997,8.3824 18.7786761,5.6614 L18.7786761,5.6614 Z M14.0001313,5 L14.0001313,27 L5.00004688,20 L5.00004688,11.949 L14.0001313,5 Z M3.00002813,11.997 L3.00002813,20 L2,20 C0.8954305,20 -3.55256646e-16,19.1045695 0,18 L0,18 L0,14 C0.00200098123,12.8962115 0.896213013,12.0011048 1.999999,11.998 L1.999999,11.998 L3.00002813,11.997 Z",
    id: 272
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionAudio);
export default __webpack_public_path__ + "static/media/navigation-and-action-audio.ad7b4291.svg";
export { ForwardRef as ReactComponent };